import customAxios from '../api/axios'
import settings from '../../../config/settings'

const {apiBaseURL} = settings

export default class LucidApi {
  static redirectComplete(campaignId) {
    return customAxios.post(`${apiBaseURL}/lucid/redirect/complete`, {
      campaignId,
    })
  }

  static redirectOverquota(campaignId) {
    return customAxios.post(`${apiBaseURL}/lucid/redirect/overquota`, {
      campaignId,
    })
  }

  static redirectTerminate(campaignId) {
    return customAxios.post(`${apiBaseURL}/lucid/redirect/terminate`, {
      campaignId,
    })
  }
}
